import { useTranslation } from 'react-i18next';
import { useScrollReveal } from '@/hooks/useScrollReveal';

const steps = [
  { numKey: 'process_1_num', titleKey: 'process_1_title', descKey: 'process_1_desc', icon: 'ri-phone-line' },
  { numKey: 'process_2_num', titleKey: 'process_2_title', descKey: 'process_2_desc', icon: 'ri-map-pin-line' },
  { numKey: 'process_3_num', titleKey: 'process_3_title', descKey: 'process_3_desc', icon: 'ri-mail-open-line' },
  { numKey: 'process_4_num', titleKey: 'process_4_title', descKey: 'process_4_desc', icon: 'ri-checkbox-circle-line' },
];

export default function ProcessTimeline() {
  const { t } = useTranslation('soumission');
  const { ref, isVisible } = useScrollReveal<HTMLElement>(0.1);

  return (
    <section ref={ref} id="process" className="bg-white py-16 md:py-24">
      <div className="max-w-6xl mx-auto px-4 md:px-6 lg:px-10">
        <div
          className={`text-center mb-12 md:mb-16 transition-all duration-1000 ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
          }`}
        >
          <h2 className="font-manrope font-bold text-slate-primary text-2xl md:text-3xl lg:text-4xl">
            {t('process_h2')}
          </h2>
        </div>

        {/* Image banner */}
        <div
          className={`rounded-xl overflow-hidden mb-10 md:mb-14 transition-all duration-1000 delay-100 ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
          }`}
        >
          <img
            src="https://readdy.ai/api/search-image?query=Professional roofing contractor walking a residential property with measuring tape and clipboard, conducting a free roof inspection and estimate for a Quebec homeowner, front yard with autumn maple trees, warm friendly consultation atmosphere, documentary business photography, no text visible"
            alt="Couvreur effectuant une inspection gratuite pour soumission de toiture à Lévis par couvreur RBQ"
            className="w-full h-48 md:h-64 object-cover object-top"
            loading="lazy"
            width="1000"
            height="350"
          />
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-4">
          {steps.map((step, idx) => (
            <div
              key={idx}
              className={`relative transition-all duration-700 ${
                isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
              }`}
              style={{ transitionDelay: `${idx * 150 + 200}ms` }}
            >
              {/* Connector line (desktop only) */}
              {idx < steps.length - 1 && (
                <div className="hidden lg:block absolute top-6 left-[60%] w-[80%] h-[2px] bg-copper/20" />
              )}

              <div className="text-center">
                <div className="w-12 h-12 flex items-center justify-center rounded-full bg-copper mx-auto mb-4 relative z-10">
                  <i className={`${step.icon} text-white text-lg`} />
                </div>
                <span className="font-manrope font-bold text-copper text-3xl block mb-2">
                  {t(step.numKey)}
                </span>
                <h3 className="font-manrope font-bold text-slate-primary text-sm md:text-base mb-2">
                  {t(step.titleKey)}
                </h3>
                <p className="text-slate-primary/50 text-xs md:text-sm leading-relaxed">
                  {t(step.descKey)}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}